/* tslint:disable */

import { ConcreteRequest } from "relay-runtime";
export type ShopWithCeoAddInput = {
    readonly ceoId?: string | null;
    readonly ceoCustomUrl?: string | null;
    readonly eventId?: string | null;
    readonly trinityDealerId?: string | null;
    readonly ceAccountId?: string | null;
    readonly clientMutationId?: string | null;
};
export type ShopWithCeoAddMutationVariables = {
    readonly input: ShopWithCeoAddInput;
};
export type ShopWithCeoAddMutationResponse = {
    readonly shopWithCeoAdd: ({
        readonly clientMutationId: string | null;
        readonly user: ({
            readonly id: string;
            readonly email: string | null;
            readonly shoppingWithCeoUser: ({
                readonly publicId: string | null;
                readonly userId: string | null;
                readonly firstName: string | null;
                readonly lastName: string | null;
                readonly profile: ({
                    readonly image: string | null;
                    readonly city: string | null;
                    readonly state: string | null;
                    readonly zip: string | null;
                }) | null;
            }) | null;
        }) | null;
        readonly cart: ({
            readonly id: string;
            readonly eventId: string | null;
            readonly billingAddress: ({
                readonly guestShoppingWithCEO: string | null;
            }) | null;
        }) | null;
        readonly cartV2: ({
            readonly id: string;
            readonly eventId: string | null;
        }) | null;
    }) | null;
};
export type ShopWithCeoAddMutation = {
    readonly response: ShopWithCeoAddMutationResponse;
    readonly variables: ShopWithCeoAddMutationVariables;
};



/*
mutation ShopWithCeoAddMutation(
  $input: ShopWithCeoAddInput!
) {
  shopWithCeoAdd(input: $input) {
    clientMutationId
    user {
      id
      email
      shoppingWithCeoUser {
        publicId
        userId
        firstName
        lastName
        profile {
          image
          city
          state
          zip
          id
        }
        id
      }
    }
    cart {
      id
      eventId
      billingAddress {
        guestShoppingWithCEO
        id
      }
    }
    cartV2 {
      id
      eventId
    }
  }
}
*/

const node: ConcreteRequest = (function () {
    var v0 = [
        ({
            "kind": "LocalArgument",
            "name": "input",
            "type": "ShopWithCeoAddInput!",
            "defaultValue": null
        } as any)
    ], v1 = [
        ({
            "kind": "Variable",
            "name": "input",
            "variableName": "input",
            "type": "ShopWithCeoAddInput!"
        } as any)
    ], v2 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "clientMutationId",
        "args": null,
        "storageKey": null
    } as any), v3 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "id",
        "args": null,
        "storageKey": null
    } as any), v4 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "email",
        "args": null,
        "storageKey": null
    } as any), v5 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "publicId",
        "args": null,
        "storageKey": null
    } as any), v6 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "userId",
        "args": null,
        "storageKey": null
    } as any), v7 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "firstName",
        "args": null,
        "storageKey": null
    } as any), v8 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "lastName",
        "args": null,
        "storageKey": null
    } as any), v9 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "image",
        "args": null,
        "storageKey": null
    } as any), v10 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "city",
        "args": null,
        "storageKey": null
    } as any), v11 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "state",
        "args": null,
        "storageKey": null
    } as any), v12 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "zip",
        "args": null,
        "storageKey": null
    } as any), v13 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "eventId",
        "args": null,
        "storageKey": null
    } as any), v14 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "guestShoppingWithCEO",
        "args": null,
        "storageKey": null
    } as any), v15 = ({
        "kind": "LinkedField",
        "alias": null,
        "name": "cartV2",
        "storageKey": null,
        "args": null,
        "concreteType": "CartV2",
        "plural": false,
        "selections": [
            (v3 /*: any*/),
            (v13 /*: any*/)
        ]
    } as any);
    return {
        "kind": "Request",
        "fragment": {
            "kind": "Fragment",
            "name": "ShopWithCeoAddMutation",
            "type": "Mutation",
            "metadata": null,
            "argumentDefinitions": (v0 /*: any*/),
            "selections": [
                {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "shopWithCeoAdd",
                    "storageKey": null,
                    "args": (v1 /*: any*/),
                    "concreteType": "ShopWithCeoAddPayload",
                    "plural": false,
                    "selections": [
                        (v2 /*: any*/),
                        {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "user",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "User",
                            "plural": false,
                            "selections": [
                                (v3 /*: any*/),
                                (v4 /*: any*/),
                                {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "shoppingWithCeoUser",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "User",
                                    "plural": false,
                                    "selections": [
                                        (v5 /*: any*/),
                                        (v6 /*: any*/),
                                        (v7 /*: any*/),
                                        (v8 /*: any*/),
                                        {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "profile",
                                            "storageKey": null,
                                            "args": null,
                                            "concreteType": "Profile",
                                            "plural": false,
                                            "selections": [
                                                (v9 /*: any*/),
                                                (v10 /*: any*/),
                                                (v11 /*: any*/),
                                                (v12 /*: any*/)
                                            ]
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "cart",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "Cart",
                            "plural": false,
                            "selections": [
                                (v3 /*: any*/),
                                (v13 /*: any*/),
                                {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "billingAddress",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "Address",
                                    "plural": false,
                                    "selections": [
                                        (v14 /*: any*/)
                                    ]
                                }
                            ]
                        },
                        (v15 /*: any*/)
                    ]
                }
            ]
        },
        "operation": {
            "kind": "Operation",
            "name": "ShopWithCeoAddMutation",
            "argumentDefinitions": (v0 /*: any*/),
            "selections": [
                {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "shopWithCeoAdd",
                    "storageKey": null,
                    "args": (v1 /*: any*/),
                    "concreteType": "ShopWithCeoAddPayload",
                    "plural": false,
                    "selections": [
                        (v2 /*: any*/),
                        {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "user",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "User",
                            "plural": false,
                            "selections": [
                                (v3 /*: any*/),
                                (v4 /*: any*/),
                                {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "shoppingWithCeoUser",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "User",
                                    "plural": false,
                                    "selections": [
                                        (v5 /*: any*/),
                                        (v6 /*: any*/),
                                        (v7 /*: any*/),
                                        (v8 /*: any*/),
                                        {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "profile",
                                            "storageKey": null,
                                            "args": null,
                                            "concreteType": "Profile",
                                            "plural": false,
                                            "selections": [
                                                (v9 /*: any*/),
                                                (v10 /*: any*/),
                                                (v11 /*: any*/),
                                                (v12 /*: any*/),
                                                (v3 /*: any*/)
                                            ]
                                        },
                                        (v3 /*: any*/)
                                    ]
                                }
                            ]
                        },
                        {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "cart",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "Cart",
                            "plural": false,
                            "selections": [
                                (v3 /*: any*/),
                                (v13 /*: any*/),
                                {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "billingAddress",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "Address",
                                    "plural": false,
                                    "selections": [
                                        (v14 /*: any*/),
                                        (v3 /*: any*/)
                                    ]
                                }
                            ]
                        },
                        (v15 /*: any*/)
                    ]
                }
            ]
        },
        "params": {
            "operationKind": "mutation",
            "name": "ShopWithCeoAddMutation",
            "id": null,
            "text": "mutation ShopWithCeoAddMutation(\n  $input: ShopWithCeoAddInput!\n) {\n  shopWithCeoAdd(input: $input) {\n    clientMutationId\n    user {\n      id\n      email\n      shoppingWithCeoUser {\n        publicId\n        userId\n        firstName\n        lastName\n        profile {\n          image\n          city\n          state\n          zip\n          id\n        }\n        id\n      }\n    }\n    cart {\n      id\n      eventId\n      billingAddress {\n        guestShoppingWithCEO\n        id\n      }\n    }\n    cartV2 {\n      id\n      eventId\n    }\n  }\n}\n",
            "metadata": {}
        }
    } as any;
})();
(node as any).hash = '76673eb5823bc04369f1394c75436bde';
export default node;
